import { pxToRem, responsiveFontSizes } from './utils/getFontValue';

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    statistic: true;
  }
}

const FONT_PRIMARY = 'Mont-Regular';
const FONT_BOLD = 'Mont-Bold';
const FONT_SEMIBOLD = 'Mont-SemiBold';

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: FONT_BOLD,
    fontWeight: 700,
    lineHeight: 80 / 64,
    fontSize: pxToRem(40),
    letterSpacing: -1,
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
  },
  h2: {
    fontFamily: FONT_BOLD,
    fontWeight: 700,
    lineHeight: 64 / 48,
    fontSize: pxToRem(32),
    letterSpacing: -1,
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    fontFamily: FONT_BOLD,
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(24),
    letterSpacing: -1,
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
  },
  h4: {
    fontFamily: FONT_BOLD,
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(20),
    letterSpacing: -1,
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
  h5: {
    fontFamily: FONT_BOLD,
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    letterSpacing: -1,
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  h6: {
    fontFamily: FONT_BOLD,
    fontWeight: 700,
    lineHeight: 28 / 18,
    fontSize: pxToRem(17),
    letterSpacing: -1,
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
    letterSpacing: -1,
  },
  subtitle2: {
    fontFamily: FONT_BOLD,
    fontWeight: 600,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
    letterSpacing: -1,
  },
  body1: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
    letterSpacing: -1,
  },
  body2: {
    fontWeight: 400,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
    letterSpacing: -1,
  },
  caption: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    letterSpacing: -1,
    fontFamily: FONT_SEMIBOLD,
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  button: {
    fontFamily: FONT_BOLD,
    fontWeight: 800,
    lineHeight: 24 / 14,
    fontSize: pxToRem(15),
    textTransform: 'inherit',
    letterSpacing: -1,
  },
  statistic: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(28),
    letterSpacing: -1,
  },
} as const;

export default typography;
